<template>
  <div class="configurador">
    <component :is="configurador" />
  </div>
</template>

<script>
import NoExiste from '@/views/NoExiste.vue'

export default {
  name: 'Configurador',
  components: {
    'configurador-usuarioszona': () =>
      import(
        /* webpackPrefetch: true */ '@/components/configurador/usuariosZona/UsuariosZona.vue'
      )
  },
  computed: {
    configurador() {
      const configurador = this.$route.params.id.toLowerCase()
      switch (configurador) {
        case 'usuarioszona':
          return `configurador-${configurador}`
        default:
          return NoExiste
      }
    }
  }
}
</script>
